import { faCalendarClock } from "@fortawesome/pro-regular-svg-icons";

import { toDate, toRelativeDate } from "common/utils/dates";
import Icon from "common/components/Icon";

import styles from "../styles/SubscriptionDateBanners.module.less";

type SubscriptionDateBannersProps = {
  dates: Date[];
};

const SubscriptionDateBanners = ({ dates }: SubscriptionDateBannersProps) => {
  return (
    <div className={styles.container}>
      {dates.map((date) => (
        <div className={styles.banner} key={date.getTime()}>
          <div className={styles.icon}>
            <Icon icon={faCalendarClock} />
          </div>
          <div className={styles.content}>
            <div className={styles.date}>{toDate(date)}</div>
            <div className={styles.relative}>{toRelativeDate(date)}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionDateBanners;
